module.exports = __webpack_public_path__ + "static/media/Seam_3122.43edb2a8.jpg";